module.exports = __webpack_public_path__ + "img/Anhänger_NEA_200kVA.4361af10.svg";